import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { CommonModule, isPlatformBrowser } from '@angular/common';
import { RouterModule } from '@angular/router';

declare var gtag: any;

@Component({
  selector: 'app-footer',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <!-- Social Sharing Buttons -->
    <div class="social-share">
      <h3>Síguenos en redes sociales</h3>
      <div class="social-buttons">
        <a href="https://www.facebook.com/profile.php?id=61572549553204" target="_blank" rel="noopener" aria-label="Síguenos en Facebook">
          <img src="/icons/facebook.svg" alt="Facebook" class="social-icon" width="24" height="24">
        </a>
        <a href="https://x.com/pezetasolutions" target="_blank" rel="noopener" aria-label="Síguenos en Twitter">
          <img src="/icons/twitter.svg" alt="Twitter" class="social-icon" width="24" height="24">
        </a>
        <a href="https://www.instagram.com/pezetasolutions" target="_blank" rel="noopener" aria-label="Síguenos en Instagram">
          <img src="/icons/instagram-brands-solid-full.svg" alt="Instagram" class="social-icon" width="24" height="24">
        </a>
      </div>
    </div>

    <!-- WhatsApp Floating Button -->
    <div class="whatsapp-float" (click)="openWhatsApp()" aria-label="Contactar por WhatsApp">
      <img src="/icons/whatsapp.svg" alt="WhatsApp" class="whatsapp-icon" width="20" height="20">
      <span class="whatsapp-text">WhatsApp</span>
    </div>

    <!-- Footer -->
    <footer class="footer" role="contentinfo">
      <div class="container">
        <div class="footer-content">
          <div class="footer-logo">
            <picture>
              <source srcset="/images/white-logo-80.webp" type="image/webp">
              <img 
                src="/images/white-logo-80.webp" 
                alt="Logo Pezeta Solutions - Desarrollo de software personalizado en Sinaloa, México" 
                class="footer-logo-img" 
                width="40" 
                height="40" 
                loading="lazy"
              >
            </picture>
            <span class="footer-logo-text">Pezeta Solutions</span>
          </div>
          <div class="footer-links">
            <a routerLink="/" title="Ir a la página de inicio" aria-label="Página de inicio">Inicio</a>
            <a routerLink="/blogs" title="Leer artículos del blog" aria-label="Blog de Chatbot Pezeta">Blog</a>
            <a routerLink="/login" title="Acceder a tu cuenta" aria-label="Acceder al sistema">Acceder</a>
            <a routerLink="/politicas-de-privacidad" title="Ver política de privacidad" aria-label="Política de privacidad">Privacidad</a>
            <a routerLink="/terminos-y-condiciones" title="Ver términos y condiciones" aria-label="Términos y condiciones">Términos</a>
          </div>
          <div class="footer-pages">
            <span class="footer-pages-title">Enlaces útiles:</span>
            <a routerLink="/blogs" title="Leer artículos sobre chatbots y automatización" aria-label="Artículos del blog">Artículos del blog</a>
            <a routerLink="/partners" title="Programa de comisionistas - Gana vendiendo ChatbotPezeta" aria-label="Programa de comisionistas">Comisionistas</a>
            <a routerLink="/politicas-de-privacidad" title="Política de privacidad de Chatbot Pezeta" aria-label="Política de privacidad">Política de privacidad</a>
            <a routerLink="/terminos-y-condiciones" title="Términos y condiciones de Chatbot Pezeta" aria-label="Términos y condiciones">Términos y condiciones</a>
            <a routerLink="/eliminacion-de-datos" title="Solicitar eliminación de datos personales" aria-label="Eliminación de datos">Eliminación de datos</a>
          </div>
        </div>
        <div class="footer-bottom">
          <p>&copy; {{ currentYear }} Pezeta Solutions. Todos los derechos reservados.</p>
          <p class="privacy-link">
            <a routerLink="/politicas-de-privacidad" title="Ver política de privacidad" aria-label="Política de privacidad">Política de Privacidad</a>
            <span class="link-separator" aria-hidden="true">|</span>
            <a routerLink="/terminos-y-condiciones" title="Ver términos y condiciones" aria-label="Términos y condiciones">Términos y Condiciones</a>
            <span class="link-separator" aria-hidden="true">|</span>
            <a routerLink="/eliminacion-de-datos" title="Solicitar eliminación de datos" aria-label="Eliminación de datos">Eliminación de Datos</a>
          </p>
        </div>
      </div>
    </footer>
  `,
  styleUrls: ['./footer.component.css']
})
export class FooterComponent {
  currentYear = new Date().getFullYear();

  constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

  private sendGAEvent(eventName: string, params: any = {}) {
    if (isPlatformBrowser(this.platformId) && typeof gtag !== 'undefined') {
      gtag('event', eventName, params);
    }
  }

  openWhatsApp() {
    if (isPlatformBrowser(this.platformId)) {
      this.sendGAEvent('click', {
        link_url: 'https://wa.me/message/GTV3AEMP6MFNC1',
        platform: 'whatsapp_button',
        component: 'footer_floating_button'
      });

      window.open('https://wa.me/message/GTV3AEMP6MFNC1', '_blank');
    }
  }
}